var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton, Typography } from '@robinpowered/ui-kit';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { useEventDetailContext } from '../context/EventDetailContextProvider';
import { useEventApi } from '../../hooks/useEvent/useEventApi';
import { useConfig } from '../../context/ConfigContext';
import { getRecurrenceEndDate, parseMultipleRecurrenceRules, } from '../../utils/parsers';
export var RecurrenceText = function () {
    var t = useTranslation('meetingRooms').t;
    var _a = useConfig(), environmentUrls = _a.environmentUrls, userContext = _a.userContext, tenantId = _a.tenantId, accessToken = _a.accessToken;
    var apiUrl = environmentUrls.apiUrl, baseApiUrl = environmentUrls.baseApiUrl;
    var currentOrg = userContext.currentOrg;
    var _b = useEventDetailContext(), event = _b.event, onError = _b.onError;
    var fetchEventSeries = useEventApi({
        onError: onError,
        apiUrl: apiUrl,
        baseApiUrl: baseApiUrl,
        currentOrg: currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }).fetchEventSeries;
    var _c = __read(useState(undefined), 2), recurrenceText = _c[0], setRecurrenceText = _c[1];
    var _d = __read(useState(null), 2), recurrenceEndDate = _d[0], setRecurrenceEndDate = _d[1];
    var _e = __read(useState(false), 2), isLoading = _e[0], setIsLoading = _e[1];
    /* Keep a ref of event series id */
    var eventSeriesIdRef = useRef(null);
    useEffect(function () {
        if (eventSeriesIdRef.current !== (event === null || event === void 0 ? void 0 : event.series_id)) {
            if (!(event === null || event === void 0 ? void 0 : event.series_id)) {
                eventSeriesIdRef.current = null;
                setRecurrenceText(undefined);
                setRecurrenceEndDate(null);
                return;
            }
            eventSeriesIdRef.current = event.series_id;
            setIsLoading(true);
            fetchEventSeries(event.series_id)
                .then(function (eventSeries) {
                if (eventSeries && eventSeries.recurrence) {
                    eventSeriesIdRef.current = event.series_id;
                    setRecurrenceText(parseMultipleRecurrenceRules(eventSeries.recurrence));
                    setRecurrenceEndDate(getRecurrenceEndDate(eventSeries.recurrence));
                }
            })
                .catch(function (error) {
                setRecurrenceText(undefined);
                setRecurrenceEndDate(null);
                /* @TODO add onError prop from event details context */
            })
                .finally(function () {
                setIsLoading(false);
            });
        }
    }, [event === null || event === void 0 ? void 0 : event.series_id, fetchEventSeries]);
    if (isLoading) {
        return _jsx(Skeleton.Input, { active: true, style: { width: '70%', height: '12px' } });
    }
    if (!recurrenceText) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(Typography.Text, { type: "secondary", children: recurrenceText }), recurrenceEndDate && (_jsx(Typography.Text, { type: "secondary", children: t('eventDetails.recurrence_ends', {
                    date: moment(recurrenceEndDate).format('ddd, MMM D, YYYY'),
                }) }))] }));
};
